import axios from 'axios';
import { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './Login.css';

function titlee() {
  return document.getElementById('titlee');
}

let title = titlee();
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      line1: 'Login',
      textAnimationLine1: [],
      Password: 'password',
      ShowPasswordClck: false,
      CredentialChkUrl: 'https://my-webpage-node.vercel.app/Login/',
      emailAddressVal: '',
      passwordVal: '',
      errorContent: '',
      LoginPrsd: false,
      LoginText: 'Login'
    }
  }

  async componentDidMount() {
    if (this.props.localStorageData.NavBarLoginText.Login) {
      this.props.history.push('/Shan/HomePage')
    }
    title.innerHTML = 'Login'
    let tempArr1 = []
    if (this.state.textAnimationLine1.length !== 40) {
      for (let i = 0; i < 40; i++) {
        tempArr1[i] = { letterAni: 0 }
      }
    }
    this.setState({
      textAnimationLine1: tempArr1,
    })
    let LoginPage = {
      SelectedPage: 5
    }
    this.props.SelectedPage('SelectedPage', LoginPage)
    var countDownAni = 0;
    setInterval(() => {
      if ((countDownAni) < 40) {
        let arr1 = this.state.textAnimationLine1;
        if (countDownAni === 0) {
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        } else {
          arr1[countDownAni - 1] = { letterAni: 2 }
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        }
      }
    }, 100);
  }

  render() {
    if (this.props.localStorageData.NavBarLoginText.Login) {
      this.props.history.push('/Shan/HomePage')
    }
    return (<>
      {this.props.localStorageData.NavBarLoginText.Login ? '' : <>
        <div className='LoginMainDivision'>
          <div className='LoginFormDivision'>
            <div className='LoginHeadingDiv'>
              {this.state.line1.split('').map((ite, index) => {
                return (<>{ite === ' ' ? <span className='LoginAniLetterSpace'>{ite}</span> : <span onMouseEnter={() => {
                  let ani = this.state.textAnimationLine1
                  ani[index] = { letterAni: 1 }
                  this.setState({
                    textAnimationLine1: ani
                  })
                }} onMouseLeave={() => {
                  setTimeout(() => {
                    let ani = this.state.textAnimationLine1
                    ani[index] = { letterAni: 2 }
                    this.setState({
                      textAnimationLine1: ani
                    })
                  }, 500)
                }} className={this.state.textAnimationLine1[index]?.letterAni === 0 || undefined || null ? 'LoginAniLtr' : this.state.textAnimationLine1[index]?.letterAni === 1 ? 'LoginAniLetterMouse LoginAniLetter' : 'LoginAniLetter'}>{ite}</span>}
                </>)
              })}
            </div>
            <form className='LoginForm' onSubmit={async (e) => {
              e.preventDefault();
              if (this.state.LoginPrsd === false) {
                this.setState({
                  LoginPrsd: true,
                  LoginText: 'Logging In'
                })
                let reqBody = {
                  authCode: "626548a4aa11b1c662c5539c",
                  method: 'verify',
                  email: this.state.emailAddressVal,
                  password: this.state.passwordVal
                }
                await axios.post(this.state.CredentialChkUrl, reqBody).then((e) => {
                  if (e.data.match) {
                    this.setState({
                      LoginPrsd: false
                    })
                    let Data = this.props.localStorageData?.NavBarLoginText;
                    Data.Login = true;
                    Data.NavBarText = 'Shanmugavel\'s Data';
                    this.props.LoginText('NavBarLoginText', Data);
                    this.props.SelectedPage('LoggedInPage', { SelectedPage: 0 })
                    this.props.SelectedPage('SelectedPage', { SelectedPage: 5 })
                    this.props.history.push('/Shan/HomePage');
                  } else {
                    this.setState({
                      errorContent: 'Email or Password Entered is invalid',
                      LoginPrsd: false,
                      LoginText: 'Login'
                    })

                  }
                })
              }
            }}>
              <label className='LoginEmailLabel'>
                <div>Email ID</div>
                <input required type={'email'} value={this.state.emailAddressVal} className='LoginEmailInput' onChange={(e) => {
                  this.setState({
                    emailAddressVal: e.target.value,
                    errorContent: ''
                  })
                }} />
              </label>
              <label className='LoginPasswordLabel'>
                <div>Password</div>
                <input required type={this.state.Password} value={this.state.passwordVal} className='LoginPasswordInput' onChange={(e) => {
                  this.setState({
                    passwordVal: e.target.value,
                    errorContent: ''
                  })
                }} />
                <i className={this.state.ShowPasswordClck ? 'ShowPasswordLoginIconNone' : 'fas fa-eye ShowPasswordLogin'} onClick={(e) => {
                  if (this.state.Password === 'password') {
                    this.setState({
                      Password: 'text',
                      ShowPasswordClck: !this.state.ShowPasswordClck
                    })
                  } else {
                    this.setState({
                      Password: 'password',
                      ShowPasswordClck: !this.state.ShowPasswordClck
                    })
                  }
                }}></i>
                <i className={this.state.ShowPasswordClck ? 'fas fa-eye-slash ShowPasswordLoginSlash' : 'ShowPasswordLoginIconNone'} onClick={(e) => {
                  if (this.state.Password === 'password') {
                    this.setState({
                      Password: 'text',
                      ShowPasswordClck: !this.state.ShowPasswordClck
                    })
                  } else {
                    this.setState({
                      Password: 'password',
                      ShowPasswordClck: !this.state.ShowPasswordClck
                    })
                  }
                }}></i>
              </label>
              <div className='LoginErrorDiv'>{this.state.errorContent}</div>
              <input type={'submit'} value={this.state.LoginText} className='LoginSubmitInput' />
            </form>
          </div>
        </div>
      </>}
    </>);
  }
}

const mapStateToProps = (state) => ({
  localStorageData: state.Reducer
})

const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoadingPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoginText: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));